import { Commit } from 'vuex';
import countryService from '@core/services/country/CountryService';
import { SET_SHOPS } from '@store/modules/data/country/countryIndex';
import StoreUtil from '@app/store/StoreUtil';
import { sortShops } from '@store/modules/data/country/utils';

export const fetchShops = StoreUtil.asyncErrorGuard(async ({ commit }: { commit: Commit }) => {
    const shops = await countryService.getShops();
    commit(SET_SHOPS, sortShops(shops));
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/poland/app/store/modules/data/country/countryIndex.ts